document.addEventListener('DOMContentLoaded', () => {
    const bottomBar = document.querySelector('.product__bottom_bar');

    if (!bottomBar) return;

    const placeholderDiv = document.createElement('div');
    placeholderDiv.className = 'bottom-bar-placeholder';
    document.body.appendChild(placeholderDiv);
    updatePlaceholderHeight();

    const observer = new ResizeObserver(() => {
        updatePlaceholderHeight();
    });

    observer.observe(bottomBar);

    function updatePlaceholderHeight() {
        const height = bottomBar.offsetHeight;
        placeholderDiv.style.height = `${height}px`;
    }
});